import { ReactComponent as FrenchFlag } from "_assets/flags/french-flag.svg";
import { ReactComponent as EnglishFlag } from "_assets/flags/english-flag.svg";

const svgProperties = { width:20, height:20, style:{ verticalAlign: 'baseline' } };

export const TRANSLATES = [
    { key: 'fr', value: 'fr', icon: <FrenchFlag {...svgProperties}/> },
    { key: 'en', value: 'en', icon: <EnglishFlag {...svgProperties}/> }
];